import { Link } from "react-router-dom";
import type { ContentItem } from "@/mocks/content";
import { typeLabels } from "@/mocks/content";

interface Props {
  title: string;
  subtitle: string;
  items: ContentItem[];
  moreTo: string;
}

export default function RecommendList({ title, subtitle, items, moreTo }: Props) {
  return (
    <section className="w-full">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-950">{title}</h2>
          <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>
        </div>
        <Link to={moreTo} className="whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700">
          更多 <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      {items.length === 0 ? (
        <p className="rounded-lg bg-background-100 p-6 text-center text-sm text-foreground-500">
          暂无推荐内容
        </p>
      ) : (
        <ul className="space-y-3">
          {items.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/detail/${item.id}`}
                className="group flex gap-4 rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <span className="flex h-6 w-6 shrink-0 items-center justify-center self-center rounded bg-background-100 font-label text-xs font-bold text-foreground-500">
                  {index + 1}
                </span>
                <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md sm:h-24 sm:w-16">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 快猫`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded bg-primary-100 px-1.5 py-0.5 font-label font-medium text-primary-700">
                      {typeLabels[item.type]}
                    </span>
                    <span>{item.author}</span>
                  </div>
                  <h3 className="mt-1.5 line-clamp-1 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{item.summary}</p>
                </div>
                {item.type !== "news" && (
                  <div className="hidden shrink-0 flex-col items-end justify-center pr-2 sm:flex">
                    <span className="flex items-center gap-1 font-label text-sm font-bold text-primary-600">
                      <i className="ri-fire-line" />
                      {item.heat.toLocaleString()}
                    </span>
                    <span className="mt-1 text-xs text-foreground-500">热度</span>
                  </div>
                )}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}